import { FC, useState } from 'react';
import { FormikProps } from 'formik';

import { ITavusPersonaFormik } from 'entities/tavus/persona';

import { General } from './General';
import { Tabs } from 'shared/ui';
import { Perception } from './Perception';
import { Tools } from './Tools';

interface IProps {
  formik: FormikProps<ITavusPersonaFormik>;
}
const tabs = ['General', 'Perception', 'Tools'];
export const AvatarEditPersonaForm: FC<IProps> = ({ formik }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const renderTab = () => {
    switch (activeTab) {
      case 'General':
        return <General formik={formik} />;
      case 'Perception':
        return <Perception formik={formik} />;
      case 'Tools':
        return <Tools formik={formik} />;
    }
  };
  return (
    <div className="ag-flex ag-flex-col ag-gap-y-6 ag-h-full ag-max-h-full">
      <Tabs setActiveTab={setActiveTab} activeTab={activeTab} tabs={tabs} />
      <div className="ag-h-full ag-overflow-y-auto">{renderTab()}</div>
    </div>
  );
};
